










































































import Vue from 'vue'
import CurrenciesForm from '@morpheus/currency/admin-vue/components/CurrenciesForm.vue'
import { PriceData } from '../types'
import { fetchProductsList } from '@morpheus/product/admin-vue/services/products-client'
import { ProductsListData, ProductShowData } from '@morpheus/product/admin-vue/types'

export default Vue.extend({
  name: 'ShopListingForm',
  components: {
    CurrenciesForm
  },
  props: {
    item: {
      required: false,
      type: Object,
      default: () => ({})
    },
    currenciesListArray: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      productsList: [],
      search: null,
      loading: false,
      componentKey: 0,
      selectedCurrencies: [] as Array<string>,
      sku: '',
      tags: [],
      price: {
        currencies: {
          '': 0
        }
      } as PriceData
    }
  },
  computed: {
    canAddCurrency (): boolean {
      return Object.keys(this.price.currencies).length !== this.currenciesListArray.length
    }
  },
  watch: {
    sku (newValue) {
      this.$emit('updateSku', newValue)
    },
    tags (newValue) {
      this.$emit('updateTags', newValue)
    },
    item: {
      immediate: true,
      handler () {
        this.sku = this.item.sku
        this.tags = this.item.tags ? this.item.tags : []
        this.price = Object.assign({}, this.price, this.item.price)
      }
    },
    search (val) {
      val && this.querySelections(val)
    }
  },
  mounted () {
    this.fetchSearchItems('')
  },
  methods: {
    fetchSearchItems (params: string) {
      fetchProductsList(params)
        .then(({ items, total }: ProductsListData) => {
          items.forEach((item: ProductShowData, index: number) => {
            Vue.set(this.productsList, index, item)
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.loading = false
          this.$store.commit('global/setLoading', false)
        })
    },
    querySelections (v: string) {
      this.loading = true

      this.fetchSearchItems(`?query=${v}`)
    },
    onUpdatePriceCurrencies (amount: number, currency: string, oldCurrency: string) {
      const currencies = Object.assign({}, this.price.currencies)
      currencies[currency] = amount
      if (currencies.hasOwnProperty(oldCurrency)) {
        delete currencies[oldCurrency]
      }
      if (oldCurrency) {
        this.selectedCurrencies.splice(this.selectedCurrencies.indexOf(oldCurrency), 1)
      }
      if (this.selectedCurrencies.indexOf(currency) === -1) {
        this.selectedCurrencies.push(currency)
      }
      delete currencies['']
      if (currency) {
        this.price.currencies = currencies
      }
      this.$emit('updatePriceCurrencies', currencies)
    },
    addCurrency () {
      this.price.currencies = Object.assign({}, this.price.currencies, { '': 0 })
    },
    removeCurrency (currency: string) {
      Vue.delete(this.price.currencies, currency)
      this.selectedCurrencies = this.selectedCurrencies.filter(e => e !== currency)

      // rerender ShopCurrencyListingForm component
      this.componentKey += 1
    }
  }
})
